export const manifest = {
  screens: {
    scr_kp0esk: { name: "Cover", route: "/", state: {"slide":0}, position: {"x":160,"y":220} },
    scr_skshpg: { name: "Executive Summary", route: "/", state: {"slide":1}, position: {"x":1560,"y":220} },
    scr_aqx7nl: { name: "Current Situation", route: "/", state: {"slide":2}, position: {"x":2960,"y":220} },
    scr_wyirxp: { name: "Strategic Opportunity", route: "/", state: {"slide":3}, position: {"x":4360,"y":220} },
    scr_7cn1mx: { name: "Proposed Campaign Model", route: "/", state: {"slide":4}, position: {"x":5760,"y":220} },
    scr_7gr8tf: { name: "What Is a Teaser?", route: "/", state: {"slide":5}, position: {"x":7160,"y":220} },
    scr_ywg6kj: { name: "What Is a Trailer / Microsite?", route: "/", state: {"slide":6}, position: {"x":8560,"y":220} },
    scr_qyxnts: { name: "Master-Based Production Logic", route: "/", state: {"slide":7}, position: {"x":9960,"y":220} },
    scr_0rvdr9: { name: "Asset Lifespan Recommendation", route: "/", state: {"slide":8}, position: {"x":11360,"y":220} },
    scr_d6hclb: { name: "6-Month Proposal", route: "/", state: {"slide":9}, position: {"x":12760,"y":220} },
    scr_q450k3: { name: "12-Month Proposal", route: "/", state: {"slide":10}, position: {"x":14160,"y":220} },
    scr_uo787h: { name: "Why 12 Months Is Recommended", route: "/", state: {"slide":11}, position: {"x":15560,"y":220} },
    scr_0uop04: { name: "Monitoring & Optimization", route: "/", state: {"slide":12}, position: {"x":19760,"y":220} },
    scr_fv6658: { name: "Channel-Agnostic Deployment", route: "/", state: {"slide":13}, position: {"x":16960,"y":220} },
    scr_7pw8ar: { name: "Timeline & Approvals", route: "/", state: {"slide":14}, position: {"x":18360,"y":220} },
    scr_8ph695: { name: "Next Steps", route: "/", state: {"slide":15}, position: {"x":21160,"y":220} },
    scr_5vmyfr: { name: "Closing Recommendation", route: "/", state: {"slide":16}, position: {"x":22560,"y":220} },
  },
  sections: {
    sec_cmsdzd: { name: "Business Proposal Flow", x: 0, y: 0, width: 23920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_cmsdzd", children: [
      { kind: "screen", id: "scr_kp0esk" },
      { kind: "screen", id: "scr_skshpg" },
      { kind: "screen", id: "scr_aqx7nl" },
      { kind: "screen", id: "scr_wyirxp" },
      { kind: "screen", id: "scr_7cn1mx" },
      { kind: "screen", id: "scr_7gr8tf" },
      { kind: "screen", id: "scr_ywg6kj" },
      { kind: "screen", id: "scr_qyxnts" },
      { kind: "screen", id: "scr_0rvdr9" },
      { kind: "screen", id: "scr_d6hclb" },
      { kind: "screen", id: "scr_q450k3" },
      { kind: "screen", id: "scr_uo787h" },
      { kind: "screen", id: "scr_fv6658" },
      { kind: "screen", id: "scr_7pw8ar" },
      { kind: "screen", id: "scr_0uop04" },
      { kind: "screen", id: "scr_8ph695" },
      { kind: "screen", id: "scr_5vmyfr" },
    ] },
  ],
}
